import { db, fb } from "../firebase";
import fn from "../pages/data/adminRequest";
const uuid = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getRows = (appId, tableId, rowIds, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/rows`,
    method: "post",
    user: user,
    body: {
      rows: rowIds,
    },
  })
    .then((result) => {
      if (result.data.err) throw new Error(result.data);
      return result.data;
    })
    .catch((err) => err);
};

export const updateRow = (appId, tableId, rowId, data, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/rows/${rowId}`,
    method: "patch",
    user: user,
    body: {
      rowData: data,
    },
  })
    .then((result) => {
      if (result.data.err) throw new Error(result.data);
      return result.data;
    })
    .catch((err) => err);
};

export const updatePermissions = (appId, data, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: "permissions/update",
    method: "patch",
    user: user,
    body: {
      permissions: data,
    },
  })
    .then((result) => {
      if (result.data.err) throw new Error(result.data);
      return result.data;
    })
    .catch((err) => err);
};

export const createRow = (appId, tableId, data, user) => {
  const _id = uuid(33);
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/rows/create`,
    method: "post",
    user: user,
    body: {
      rowData: {
        _id: _id,
        ...data,
      },
    },
  })
    .then((result) => {
      if (result.data.err) throw new Error(result.data);
      return result.data;
    })
    .catch((err) => err);
};

export const getTable = (appId, id, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `table/${id}`,
    method: "get",
    user: user,
  })
    .then((result) => {
      if (result.err) throw new Error(result);
      return result.data;
    })
    .catch((err) => err);
};

export const createTable = async (appId, tableName, user) => {
  const _id = "_" + uuid(16);
  const dbReq = await fn({
    appId: appId,
    version: "development",
    url: "table",
    method: "post",
    user: user,
    body: {
      table: _id,
    },
  })
    .then((results) => results.data)
    .catch((err) => ({ error: err }));

  if (dbReq.error) return dbReq;

  await db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(_id)
    .set({
      fields: {
        createdBy: {
          type: "user",
          list: false,
          editable: false,
          name: "Created By",
        },
        createdDate: {
          type: "Date",
          list: false,
          editable: false,
          name: "Created Date",
        },
        modifiedDate: {
          type: "Date",
          list: false,
          editable: false,
          name: "Modified Date",
        },
        _id: {
          type: "Text",
          list: false,
          editable: false,
          name: "ID",
        },
      },
      name: tableName,
    });

  return dbReq;
};

export const createField = async (appId, tableId, field, user) => {
  const _id = "_" + uuid(16);
  const dbReq = await fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/column`,
    method: "post",
    user: user,
    body: {
      column: {
        name: _id,
        dataType: field.type.sqlType,
        list: field.hasOwnProperty("list") ? field.list : false,
      },
    },
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results;
    })
    .catch((err) => err);

  if (dbReq.err) return dbReq;

  await db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(tableId)
    .update({
      [`fields.${_id}`]: { ...field, type: field.type.name },
    });

  return dbReq;
};

export const renameField = (appId, tableId, field, name) => {
  return db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(tableId)
    .update({
      [`fields.${field}.name`]: name,
    })
    .then(() => "rename complete")
    .catch(() => "an error occured during rename");
};

export const renameTable = (appId, tableId, name) => {
  return db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(tableId)
    .update({ name: name })
    .then(() => "table rename complete")
    .catch(() => "an error occured duing table rename");
};

export const deleteTable = async (appId, tableId, user) => {
  const dbReq = await fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}`,
    method: "delete",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results;
    })
    .catch((err) => err);

  if (dbReq.err) return dbReq;

  const tableRef = db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(tableId);

  await tableRef.delete();

  return dbReq;
};

export const deleteField = async (appId, tableId, field, user) => {
  const dbReq = await fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/column/${field}`,
    method: "delete",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results;
    })
    .catch((err) => err);

  if (dbReq.err) return dbReq;

  await db
    .collection("apps")
    .doc(appId)
    .collection("tables")
    .doc(tableId)
    .update({
      [`fields.${field}`]: fb.firestore.FieldValue.delete(),
    });

  return dbReq;
};

export const getFields = (appId, tableId, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/columns`,
    method: "get",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const deleteRow = (appId, tableId, rowId, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/rows/${rowId}`,
    method: "delete",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const getTablePermissions = (appId, tableId, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `permissions/table/${tableId}`,
    method: "get",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const getRolePermissions = (appId, roleId, user) => {
  return new Promise((res) => res([]));
  return fn({
    appId: appId,
    version: "development",
    url: `role/${roleId}`,
    method: "get",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const createRole = (appId, tables, name, user) => {
  const _id = "_" + uuid(16);
  return fn({
    appId: appId,
    version: "development",
    url: `role`,
    method: "post",
    user: user,
    body: {
      id: _id,
      name: name,
      tables: tables,
    },
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const deleteRole = (appId, roleId, user) => {
  return fn({
    appId: appId,
    version: "development",
    url: `role/${roleId}`,
    method: "delete",
    user: user,
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};

export const importCSV = (appId, tableId, file, fields, user) => {
  console.log("importing csv file to database");
  return fn({
    appId: appId,
    version: "development",
    url: `table/${tableId}/import`,
    method: "post",
    user: user,
    body: {
      file: file,
      fields: fields,
    },
  })
    .then((results) => {
      if (results.err) throw new Error(results);
      return results.data;
    })
    .catch((err) => err);
};
